import { useState } from 'react';
import { DefaultTask } from '@/components/OnboardingTaskSetup';

export interface OnboardingState {
  currentStep: number;
  searchQuery: string;
  searchResults: any[];
  isSearching: boolean;
  selectedAction: 'join' | 'create' | '';
  selectedOrganization: any;
  organizationName: string;
  organizationColor: string;
  organizationLogo: File | null;
  defaultTasks: DefaultTask[];
  isNameTaken: boolean;
  isCheckingName: boolean;
  isProcessing: boolean;
  selectedCountry: string;
  selectedState: string;
  selectedCity: string;
  generatedTeamName: string;
}

export const useOnboardingState = () => {
  const [state, setState] = useState<OnboardingState>({
    currentStep: 1,
    searchQuery: '',
    searchResults: [],
    isSearching: false,
    selectedAction: '',
    selectedOrganization: null,
    organizationName: '',
    organizationColor: '#3B82F6',
    organizationLogo: null,
    defaultTasks: [],
    isNameTaken: false,
    isCheckingName: false,
    isProcessing: false,
    selectedCountry: '',
    selectedState: '',
    selectedCity: '',
    generatedTeamName: ''
  });

  const updateState = (updates: Partial<OnboardingState>) => {
    setState(prev => ({ ...prev, ...updates }));
  };

  return { state, updateState };
};